var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcResponses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF1DB",
    d: "M48.75 60h-37.5C5.036 60 0 54.964 0 48.75v-37.5C0 5.036 5.036 0 11.25 0h37.5C54.964 0 60 5.036 60 11.25v37.5C60 54.964 54.964 60 48.75 60z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFBA48",
    fillRule: "nonzero",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.829 3.788h-6.25c-.69 0-1.25-.56-1.25-1.25s.558-1.249 1.248-1.249h6.25c.69 0 1.25.56 1.25 1.25s-.558 1.25-1.248 1.25zM18.829 8.79h-6.25c-.69 0-1.25-.562-1.25-1.252s.56-1.25 1.25-1.25h6.25c.69 0 1.25.56 1.25 1.25s-.56 1.251-1.25 1.251zM18.829 13.79h-6.25c-.69 0-1.25-.56-1.25-1.25s.56-1.252 1.25-1.252h6.25c.69 0 1.25.561 1.25 1.251 0 .69-.56 1.25-1.25 1.25zM6.641 6.29H2.267C1.06 6.29.079 5.31.079 4.102V2.227c0-1.206.98-2.189 2.188-2.189H6.64c1.206 0 2.188.981 2.188 2.189v1.875C8.827 5.307 7.847 6.29 6.641 6.29zM6.641 15.038H2.267c-1.206 0-2.188-.98-2.188-2.188v-1.875c0-1.205.98-2.188 2.188-2.188H6.64c1.206 0 2.188.98 2.188 2.188v1.875c-.002 1.208-.982 2.188-2.188 2.188z",
    transform: "translate(19.922 24.96)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA48",
    fillRule: "nonzero",
    d: "M41.25 16.25h-22.5C16.682 16.25 15 17.934 15 20v20.001c0 2.068 1.682 3.75 3.75 3.75h22.5c2.068 0 3.75-1.682 3.75-3.75v-20c0-2.069-1.682-3.75-3.75-3.75zm0 25h-22.5c-.69 0-1.25-.56-1.25-1.25V22.5h25V40c0 .69-.56 1.25-1.25 1.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcResponses);
export default __webpack_public_path__ + "static/media/ic-responses.1290f72c.svg";
export { ForwardRef as ReactComponent };